import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { queryCache, useMutation } from "react-query";

import { Button, Dialog, showNotification } from "fe-shared/src/components";
import { CloseIcon } from "fe-shared/src/components/Icons";

import {
  REQUESTS_QUERY_KEY,
  REQUEST_ACTIVITIES_QUERY_KEY,
  REQUESTS_NAVIGATION_QUERY_KEY,
  REQUEST_LIST_INFO_QUERY_KEY,
} from "consts";

import * as api from "./modules/api";

interface Props {
  requestNumber: string;
}

const PickupRequestForceCompleteButton = (props: Props) => {
  const { requestNumber } = props;
  const { t } = useTranslation();
  const [isModalActive, setIsModalActive] = useState(false);

  const [forceComplete, forceCompleteResult] = useMutation(
    () => api.forceCompletePickupRequest(requestNumber),
    {
      onSuccess: () => {
        setIsModalActive(false);
        queryCache.invalidateQueries(REQUESTS_QUERY_KEY);
        queryCache.invalidateQueries([
          REQUEST_ACTIVITIES_QUERY_KEY,
          requestNumber,
        ]);
        queryCache.invalidateQueries(REQUESTS_NAVIGATION_QUERY_KEY);
        queryCache.invalidateQueries(REQUEST_LIST_INFO_QUERY_KEY);
        showNotification(t("pickupRequests.details.forceCompleteSuccess"));
      },
      onError: () => {
        showNotification(
          t("pickupRequests.details.forceCompleteError"),
          undefined,
          CloseIcon
        );
      },
    }
  );

  return (
    <>
      <Button
        id="request-force-complete-button"
        variant="outlined"
        disabled={forceCompleteResult.isLoading}
        onClick={() => setIsModalActive(true)}
      >
        {t("pickupRequests.details.forceComplete")}
      </Button>
      <Dialog
        modal
        isActive={isModalActive}
        onClose={() => setIsModalActive(false)}
        title={t("pickupRequests.details.forceComplete")}
        actions={[
          <Button
            id="request-force-complete-confirm"
            key="confirm"
            disabled={forceCompleteResult.isLoading}
            onClick={() => forceComplete()}
          >
            {t("pickupRequests.details.forceComplete")}
          </Button>,
          <Button
            id="request-force-complete-cancel"
            key="cancel"
            variant="outlined"
            disabled={forceCompleteResult.isLoading}
            onClick={() => setIsModalActive(false)}
          >
            {t("pickupRequests.details.cancel")}
          </Button>,
        ]}
      >
        <p>{t("pickupRequests.details.forceCompleteConfirm")}</p>
      </Dialog>
    </>
  );
};

export default PickupRequestForceCompleteButton;
